// 不在后台“合并 block 数据”，而是在前端把第二个 section 已经渲染出来的“产品列 DOM”剪切（ appendChild 会移动节点而不是复制）到第一个 section 的 .grid 以及下拉框选项里；再把第二个 section 整个从 DOM 树移除，因此页面上只剩一个 section，但列数包含两边的产品。
(() => {
  const stateBySection = new WeakMap();

  const getTemplateSuffix = () => {
    const html = document.documentElement;
    const body = document.body;
    return (body && body.getAttribute('data-name')) || (html && html.getAttribute('data-name')) || '';
  };

  const findComparisonSections = () => {
    const containers = Array.from(
      document.querySelectorAll('.new-collection-container-swiper, .collection-product-feature-swiper-container')
    );

    const wrappers = containers
      .map((container) => {
        return (
          container.closest('[id^="shopify-section-"]') ||
          container.closest('.shopify-section') ||
          container
        );
      })
      .filter(Boolean);

    const uniqueWrappers = [];
    const seen = new Set();
    wrappers.forEach((el) => {
      if (seen.has(el)) return;
      seen.add(el);
      if (!el.querySelector('.nfcc-container-normal .grid')) return;
      uniqueWrappers.push(el);
    });

    return uniqueWrappers;
  };

  const isLabelColumn = (el) => {
    if (!el) return false;
    return el.classList.contains('grid_item_label') || el.classList.contains('grid__item_label');
  };

  const getProductHandleFromGridItem = (gridItemEl) => {
    if (!gridItemEl) return '';
    const forcedHandle = gridItemEl.getAttribute('data-current-handle');
    if (forcedHandle) return forcedHandle;
    const activeOption = gridItemEl.querySelector('.option-box .option-cell.active');
    if (activeOption && activeOption.getAttribute('data-name')) {
      return activeOption.getAttribute('data-name');
    }
    const cls = Array.from(gridItemEl.classList).find(
      (c) => c.startsWith('grid_item_') && c !== 'grid_item_label'
    );
    return cls ? cls.replace('grid_item_', '') : '';
  };

  const getProductTitleFromGridItem = (gridItemEl) => {
    if (!gridItemEl) return '';
    const firstCell = gridItemEl.querySelector('.select-box .first-cell span');
    if (firstCell && firstCell.textContent) return firstCell.textContent.trim();
    const title = gridItemEl.querySelector('.new-feature-title');
    if (title && title.textContent) return title.textContent.trim();
    return '';
  };

  const cloneGridItems = (targetSection, sourceSection, gridSelector) => {
    const targetGrid = targetSection.querySelector(gridSelector);
    const sourceGrid = sourceSection.querySelector(gridSelector);
    if (!targetGrid || !sourceGrid) return false;

    const sourceColumns = Array.from(sourceGrid.querySelectorAll('.grid__item_product'));
    const sourceProductColumns = sourceColumns.filter((el) => !isLabelColumn(el));
    if (!sourceProductColumns.length) return false;

    sourceProductColumns.forEach((el) => {
      const cloned = el.cloneNode(true);
      cloned.setAttribute('data-merged-from', 'comparison-section-2');
      targetGrid.appendChild(cloned);
    });

    return true;
  };

  const moveCloneContainerIfNeeded = (targetSection, sourceSection) => {
    const targetHasCloneGrid = !!targetSection.querySelector('.nfcc-container-clone .grid');
    const sourceCloneContainer = sourceSection.querySelector('.nfcc-container-clone');
    if (targetHasCloneGrid || !sourceCloneContainer) return;

    const moved = sourceCloneContainer;
    moved.classList.add('hide');
    targetSection.appendChild(moved);
  };

  const getSourceProductColumnCount = (sectionEl) => {
    const sourceGrid = sectionEl.querySelector('.nfcc-container-normal .grid');
    if (!sourceGrid) return 0;
    return Array.from(sourceGrid.querySelectorAll('.grid__item_product')).filter((el) => !isLabelColumn(el))
      .length;
  };

  const getTargetProductColumnCount = (sectionEl) => {
    const grid = sectionEl.querySelector('.nfcc-container-normal .grid');
    if (!grid) return 0;
    return Array.from(grid.querySelectorAll('.grid__item_product')).filter((el) => !isLabelColumn(el))
      .length;
  };

  const getBatchOrder = (sectionEl) => {
    const grid = sectionEl.querySelector('.nfcc-container-normal .grid');
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('.grid__item_product'))
      .filter((el) => !isLabelColumn(el))
      .map((el) => getProductHandleFromGridItem(el))
      .filter(Boolean);
  };

  const getOptionBoxSample = (sectionEl) => {
    const grid = sectionEl.querySelector('.nfcc-container-normal .grid');
    if (!grid) return null;
    const item = Array.from(grid.querySelectorAll('.grid__item_product')).find((el) => !isLabelColumn(el));
    if (!item) return null;
    return item.querySelector('.select-box .option-box');
  };

  const parseOptionBoxGroups = (optionBox) => {
    const labelsByHandle = new Map();
    const newHandles = new Set();

    if (!optionBox) {
      return {
        grouped: false,
        titleNew: '',
        titleMore: '',
        newHandles,
        labelsByHandle
      };
    }

    const titles = Array.from(optionBox.querySelectorAll('.collection-category-title'))
      .map((n) => (n.textContent || '').trim())
      .filter(Boolean);

    if (titles.length >= 2) {
      let groupIndex = -1;
      Array.from(optionBox.children).forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.classList.contains('collection-category-title')) {
          groupIndex += 1;
          return;
        }
        if (!node.classList.contains('option-cell')) return;
        const handle = node.getAttribute('data-name');
        if (!handle) return;
        const labelNode = node.querySelector('.option-cell-inner');
        const label = (labelNode ? labelNode.textContent : node.textContent || '').trim();
        if (label && !labelsByHandle.has(handle)) labelsByHandle.set(handle, label);
        if (groupIndex <= 0) newHandles.add(handle);
      });

      return {
        grouped: true,
        titleNew: titles[0] || '',
        titleMore: titles[1] || '',
        newHandles,
        labelsByHandle
      };
    }

    Array.from(optionBox.querySelectorAll('.option-cell[data-name]')).forEach((node) => {
      const handle = node.getAttribute('data-name');
      if (!handle) return;
      const labelNode = node.querySelector('.option-cell-inner');
      const label = (labelNode ? labelNode.textContent : node.textContent || '').trim();
      if (label && !labelsByHandle.has(handle)) labelsByHandle.set(handle, label);
    });

    return {
      grouped: false,
      titleNew: '',
      titleMore: '',
      newHandles,
      labelsByHandle
    };
  };

  const rebuildOptionBoxes = (targetSection) => {
    const state = stateBySection.get(targetSection);
    if (!state) return;

    const rebuildInGrid = (gridEl) => {
      if (!gridEl) return;
      const items = Array.from(gridEl.querySelectorAll('.grid__item_product')).filter((el) => !isLabelColumn(el));
      items.forEach((item) => {
        const optionBox = item.querySelector('.select-box .option-box');
        if (!optionBox) return;

        const currentHandle = getProductHandleFromGridItem(item);
        while (optionBox.firstChild) optionBox.removeChild(optionBox.firstChild);

        const appendTitle = (text) => {
          if (!text) return;
          const title = document.createElement('div');
          title.className = 'collection-category-title';
          title.textContent = text;
          optionBox.appendChild(title);
        };

        const appendOption = (handle) => {
          if (!handle) return;
          const cell = document.createElement('div');
          cell.className = 'option-cell' + (handle === currentHandle ? ' active' : '');
          cell.setAttribute('data-name', handle);
          cell.setAttribute('data-merged-option', 'true');
          const inner = document.createElement('div');
          inner.className = 'option-cell-inner';
          inner.textContent = state.labelsByHandle.get(handle) || handle;
          cell.appendChild(inner);
          optionBox.appendChild(cell);
        };

        if (state.grouped) {
          appendTitle(state.titleNew);
          state.orderedNew.forEach(appendOption);
          appendTitle(state.titleMore);
          state.orderedMore.forEach(appendOption);
        } else {
          state.orderedAll.forEach(appendOption);
        }
      });
    };

    rebuildInGrid(targetSection.querySelector('.nfcc-container-normal .grid'));
    rebuildInGrid(targetSection.querySelector('.nfcc-container-clone .grid'));
  };

  const cleanComparisonText = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim();

  const buildAccessibleComparisonTable = (targetSection) => {
    targetSection.querySelector('.comparison-a11y-table')?.remove();
    const grid = targetSection.querySelector('.nfcc-container-normal .grid');
    if (!grid) return;
    const columns = Array.from(grid.querySelectorAll(':scope > .grid__item_product'));
    if (columns.length < 2) return;
    const labelColumn = columns.find(isLabelColumn) || columns[0];
    const productColumns = columns.filter((column) => column !== labelColumn && !isLabelColumn(column));
    if (!productColumns.length) return;

    const table = document.createElement('table');
    table.className = 'comparison-a11y-table visually-hidden';
    const caption = document.createElement('caption');
    caption.textContent = cleanComparisonText(targetSection.querySelector('.section-header h2')) || 'Comparación de productos';
    table.appendChild(caption);

    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    const featureHeader = document.createElement('th');
    featureHeader.scope = 'col';
    featureHeader.textContent = 'Característica';
    headerRow.appendChild(featureHeader);
    productColumns.forEach((column) => {
      const th = document.createElement('th');
      th.scope = 'col';
      th.textContent = getProductTitleFromGridItem(column) || cleanComparisonText(column.querySelector('.grid-product__meta .title')) || 'Producto';
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');
    const labelCells = Array.from(labelColumn.querySelectorAll('.product-feature-box .cell'));
    labelCells.forEach((labelCell, rowIndex) => {
      const labelNode = labelCell.querySelector('.common-label') || labelCell.querySelector('span') || labelCell;
      const label = cleanComparisonText(labelNode);
      if (!label) return;
      const row = document.createElement('tr');
      const rowHeader = document.createElement('th');
      rowHeader.scope = 'row';
      rowHeader.textContent = label;
      row.appendChild(rowHeader);
      productColumns.forEach((column) => {
        const sourceCell = column.querySelectorAll('.product-feature-box .cell')[rowIndex];
        const clone = sourceCell?.cloneNode(true);
        clone?.querySelectorAll('.common-label, .small-star').forEach((element) => element.remove());
        const cell = document.createElement('td');
        cell.textContent = cleanComparisonText(clone) || 'No indicado';
        row.appendChild(cell);
      });
      tbody.appendChild(row);
    });
    table.appendChild(tbody);
    targetSection.querySelector('.cpfsc-inner')?.prepend(table);

    targetSection.querySelectorAll('.nfcc-container-normal .product-feature-box').forEach((box) => {
      box.setAttribute('aria-hidden', 'true');
    });
  };

  const enhanceComparisonSelectors = (targetSection) => {
    targetSection.querySelectorAll('.nfcc-container-normal .select-box').forEach((selectBox, index) => {
      const optionBox = selectBox.querySelector('.option-box');
      if (!optionBox) return;
      const listboxId = `comparison-products-${index + 1}`;
      selectBox.setAttribute('role', 'combobox');
      selectBox.setAttribute('tabindex', '0');
      selectBox.setAttribute('aria-label', 'Seleccionar un producto');
      selectBox.setAttribute('aria-haspopup', 'listbox');
      selectBox.setAttribute('aria-controls', listboxId);
      selectBox.setAttribute('aria-expanded', getComputedStyle(optionBox).display !== 'none' ? 'true' : 'false');
      optionBox.id = listboxId;
      optionBox.setAttribute('role', 'listbox');
      optionBox.querySelectorAll('.option-cell').forEach((option) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.setAttribute('aria-selected', option.classList.contains('active') ? 'true' : 'false');
      });
      if (selectBox.dataset.a11yReady === 'true') return;
      selectBox.dataset.a11yReady = 'true';
      selectBox.addEventListener('click', () => {
        setTimeout(() => selectBox.setAttribute('aria-expanded', getComputedStyle(optionBox).display !== 'none' ? 'true' : 'false'), 400);
      });
      selectBox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (getComputedStyle(optionBox).display === 'none') selectBox.click();
          setTimeout(() => (optionBox.querySelector('.option-cell.active') || optionBox.querySelector('.option-cell'))?.focus(), 400);
        } else if (event.key === 'Escape' && getComputedStyle(optionBox).display !== 'none') {
          event.preventDefault();
          selectBox.click();
          selectBox.focus();
        }
      });
      selectBox.addEventListener('focusout', (event) => {
        if (!selectBox.contains(event.relatedTarget)) selectBox.setAttribute('aria-expanded', 'false');
      });
    });
  };

  const enhanceComparisonAccessibility = (targetSection) => {
    enhanceComparisonSelectors(targetSection);
    buildAccessibleComparisonTable(targetSection);
  };

  const patchOptionCellHandler = (targetSection) => {
    const $ = window.jQuery;
    if (!$) return;
    const $container = $(targetSection).find('.collection-product-swiper-container').first();
    if (!$container.length) return;

    $container.off('click keydown', '.option-cell');
    $container.on('click keydown', '.option-cell', function (e) {
      if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) {
        return;
      }

      const $cell = $(this);
      const name = $cell.data('name');
      if (!name) return;

      $cell.addClass('active').siblings().removeClass('active');

      const $gridItem = $cell.closest('.grid__item_product');
      $gridItem.removeClass('active-grid');

      $(targetSection)
        .find('.nfcc-container-normal .grid__item_product:eq(0) .product-feature-box .cell-box .cell-label')
        .remove();

      const $cloneGridItem = $(targetSection)
        .find('.nfcc-container-clone .grid-product-' + name)
        .closest('.grid__item_product')
        .first();

      if ($cloneGridItem.length) {
        $gridItem[0].setAttribute('data-current-handle', name);
        $gridItem.html($cloneGridItem.html());
        $gridItem.addClass('active-grid');
        rebuildOptionBoxes(targetSection);
        enhanceComparisonAccessibility(targetSection);
        $gridItem[0].removeAttribute('data-current-handle');
      }

      if (typeof window.autoMbHeight === 'function' && $(window).width() <= 820) {
        window.autoMbHeight();
      }
    });
  };

  const isReadyToMerge = (targetSection, sourceSection) => {
    const targetGrid = targetSection.querySelector('.nfcc-container-normal .grid');
    const sourceGrid = sourceSection.querySelector('.nfcc-container-normal .grid');
    if (!targetGrid || !sourceGrid) return false;

    const sourceCount = getSourceProductColumnCount(sourceSection);
    if (sourceCount <= 0) return false;

    return true;
  };

  const mergeAndRemove = (targetSection, sourceSection) => {
    const sourceCountBefore = getSourceProductColumnCount(sourceSection);
    if (sourceCountBefore <= 0) return false;

    const batch1Order = getBatchOrder(targetSection);
    const batch2Order = getBatchOrder(sourceSection);
    const allOrder = batch1Order.concat(batch2Order);

    const targetGroups = parseOptionBoxGroups(getOptionBoxSample(targetSection));
    const sourceGroups = parseOptionBoxGroups(getOptionBoxSample(sourceSection));
    const newHandles = new Set([...targetGroups.newHandles, ...sourceGroups.newHandles]);

    const labelsByHandle = new Map();
    targetGroups.labelsByHandle.forEach((v, k) => labelsByHandle.set(k, v));
    sourceGroups.labelsByHandle.forEach((v, k) => {
      if (!labelsByHandle.has(k)) labelsByHandle.set(k, v);
    });

    const orderedNew = allOrder.filter((h) => newHandles.has(h));
    const orderedMore = allOrder.filter((h) => !newHandles.has(h));

    stateBySection.set(targetSection, {
      grouped: targetGroups.grouped || sourceGroups.grouped,
      titleNew: targetGroups.titleNew || sourceGroups.titleNew || '',
      titleMore: targetGroups.titleMore || sourceGroups.titleMore || '',
      orderedNew,
      orderedMore,
      orderedAll: allOrder,
      labelsByHandle
    });

    const targetCountBefore = getTargetProductColumnCount(targetSection);

    const mergedNormal = cloneGridItems(targetSection, sourceSection, '.nfcc-container-normal .grid');

    const sourceHasCloneGrid = !!sourceSection.querySelector('.nfcc-container-clone .grid');
    const mergedClone = sourceHasCloneGrid
      ? cloneGridItems(targetSection, sourceSection, '.nfcc-container-clone .grid')
      : true;

    moveCloneContainerIfNeeded(targetSection, sourceSection);

    if (!mergedNormal || !mergedClone) return false;

    const sourceCountAfter = getSourceProductColumnCount(sourceSection);
    if (sourceCountAfter !== sourceCountBefore) {
      return false;
    }

    const targetCountAfter = getTargetProductColumnCount(targetSection);
    if (targetCountAfter !== targetCountBefore + sourceCountBefore) {
      return false;
    }

    targetSection.setAttribute('data-comparison-merged', 'true');

    if (sourceSection && sourceSection.parentNode) {
      sourceSection.parentNode.removeChild(sourceSection);
    }

    rebuildOptionBoxes(targetSection);
    patchOptionCellHandler(targetSection);
    enhanceComparisonAccessibility(targetSection);

    const maxForloopIndexArr = getMaxForloopIndexArr(targetSection);
    if (typeof window.comparisonAdjust === 'function') {
      setTimeout(() => {
        window.comparisonAdjust(maxForloopIndexArr);
      });
    }

    return true;
  };

  const getMaxForloopIndexArr = (targetSection) => {
    const result = [];
    for (let i = 1; i <= 8; i += 1) {
      const labelBox = targetSection.querySelector(
        `.product-feature-box${i}.product-feature-box-label`
      );
      result.push(labelBox ? labelBox.querySelectorAll('.cell-box').length : 0);
    }
    return result;
  };

  const run = () => {
    const templateSuffix = getTemplateSuffix();
    if (templateSuffix && templateSuffix !== 'collection-robot-vacuum-and-mop-comparison') return;

    const comparisonSections = findComparisonSections();
    if (!comparisonSections.length) return;

    const targetSection = comparisonSections[0];
    if (comparisonSections.length === 1) {
      enhanceComparisonAccessibility(targetSection);
      return;
    }

    if (targetSection.getAttribute('data-comparison-merged') === 'true') return;

    const sourceSection = comparisonSections[1];

    const startAt = Date.now();
    const maxWaitMs = 12000;

    const poll = () => {
      if (targetSection.getAttribute('data-comparison-merged') === 'true') return;
      if (Date.now() - startAt > maxWaitMs) return;

      if (isReadyToMerge(targetSection, sourceSection)) {
        const ok = mergeAndRemove(targetSection, sourceSection);
        if (ok) return;
      }

      requestAnimationFrame(poll);
    };

    poll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);
})();
